export const SECT_TYPE = 'payment';
export const CANCEL_LICENCE = 'cancelled-licence';

export const CANCELLED_LICENCE = [
    {
        sectionID: CANCEL_LICENCE,
        sectionName: '',
        fieldList: [
            {
                id: 'CancellationReason',
                label: 'Cancellation Reason',
                type: 'text'
            },
            {
                id: 'CancellationRemarks',
                label: 'Cancellation Remarks',
                type: 'text'
            },
            {
                id: 'CancelledSubmissionDate',
                label: 'Cancelled Submission Date',
                type: 'text'
            },
            {
                id: 'EffectiveCancellationDate',
                label: 'Effective Cancellation Date',
                type: 'text'
            }
        ]
    }
];
